var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.grid)?_c('Grid',{staticClass:"box",attrs:{"data":_vm.grid,"id":"grid"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }